import {
  IBattleAutoToggledData,
  IBattleEvent,
  IBattleFinishedData,
  IBattleRoundResolvedData,
  IBattleView
} from "@/store/apis/battleAPI/battle.types"
import { IMobCellRow } from "@/store/apis/mobsAPI/mobs.types"
import {
  IMovementCoord,
  IMovementStateResponse,
  MOVEMENT_STOP_REASON
} from "@/store/apis/worldMapAPI/worldMap.types"

export const SOCKET_NAMESPACES = {
  worldMap: "/world-map",
  cells: "/cells",
  battle: "/battle"
} as const

export const SOCKET_EVENTS = {
  movementStarted: "movement_started",
  movementRerouted: "movement_rerouted",
  movementStep: "movement_step",
  movementFinished: "movement_finished",
  movementStopped: "movement_stopped",
  cellMembership: "cell_membership",
  mobChanged: "mob_changed",
  mobRemoved: "mob_removed",
  battleStarted: "battle_started",
  battleRoundResolved: "battle_round_resolved",
  battleAutoToggled: "battle_auto_toggled",
  battleFinished: "battle_finished"
} as const

export interface IWorldMapEvent<TData> {
  type: string
  playerId: string
  mapId: string
  occurredAt: string
  data: TData
}

export type IMovementEventState = Omit<IMovementStateResponse, "status">

export interface IMovementStartedData {
  movement: IMovementEventState
}
export interface IMovementStepData {
  position: IMovementCoord
  step: { to: IMovementCoord; startedAt: string; endsAt: string }
}
export interface IMovementFinishedData {
  position: IMovementCoord
}
export interface IMovementStoppedData {
  position: IMovementCoord
  reason: MOVEMENT_STOP_REASON
}

export interface ICellRef {
  mapId: string
  x: number
  y: number
}

export interface ICellMembershipEvent {
  type: "CELL_MEMBERSHIP"
  occurredAt: string
  data: { cell: ICellRef | null }
}

export interface ICellEvent<TType extends string, TData> {
  type: TType
  mapId: string
  x: number
  y: number
  occurredAt: string
  data: TData
}

export type IMobChangedEvent = ICellEvent<"MOB_CHANGED", { mob: IMobCellRow }>
export type IMobRemovedEvent = ICellEvent<
  "MOB_REMOVED",
  { mobId: string; version: number }
>
export type IMobCellEvent = IMobChangedEvent | IMobRemovedEvent
export type ICellEventName = "mob_changed" | "mob_removed"

export interface ISocketEventPayloads {
  movement_started: IWorldMapEvent<IMovementStartedData>
  movement_rerouted: IWorldMapEvent<IMovementStartedData>
  movement_step: IWorldMapEvent<IMovementStepData>
  movement_finished: IWorldMapEvent<IMovementFinishedData>
  movement_stopped: IWorldMapEvent<IMovementStoppedData>
  cell_membership: ICellMembershipEvent
  mob_changed: IMobChangedEvent
  mob_removed: IMobRemovedEvent
  battle_started: IBattleEvent<IBattleView>
  battle_round_resolved: IBattleEvent<IBattleRoundResolvedData>
  battle_auto_toggled: IBattleEvent<IBattleAutoToggledData>
  battle_finished: IBattleEvent<IBattleFinishedData>
}
